// Seccion que hoy se lee de a una planta (Viajes, Nomina). Con el filtro en
// "Todas" pide elegir una, con un boton por planta para no mandar al operador
// a buscar el filtro. Con una planta pinta una vista por habilitacion: si la
// empresa esta habilitada en la planta por dos vias, cada una tiene su
// bandeja y su nomina, y ninguna se esconde.
import { Button } from "../components/ui/button.js";
import { Card } from "../components/ui/card.js";
import { accessesForSite, siteOptions } from "../logic/navigation.js";
import type { SectionContext } from "../shell/types.js";
import type { SiteAccess } from "../sites/port.js";

interface Props {
  context: SectionContext;
  /** Completa "Elegir una planta para ...". */
  purpose: string;
  children: (site: SiteAccess) => React.ReactNode;
}

export function SiteScoped({ context, purpose, children }: Props): React.JSX.Element {
  const accesses = accessesForSite(context.sites, context.siteId);

  if (accesses.length === 0) {
    return (
      <Card className="items-start">
        <p className="m-0 text-sm text-texto">{`Elegir una planta para ${purpose}.`}</p>
        <div role="group" aria-label="Plantas" className="flex flex-wrap gap-2">
          {siteOptions(context.sites).map((option) => (
            <Button
              key={option.siteId}
              variant="secundario"
              size="sm"
              onClick={() => {
                context.selectSite(option.siteId);
              }}
            >
              {option.name}
            </Button>
          ))}
        </div>
        <p className="m-0 text-xs text-texto-suave">La vista de todas las plantas juntas llega en una próxima versión.</p>
      </Card>
    );
  }

  return (
    <>
      {accesses.map((site) => (
        // La key remonta la vista al cambiar de planta: nada de la anterior queda en pantalla.
        <div key={`${site.siteId}:${site.providerId}`} className="contents">
          {children(site)}
        </div>
      ))}
    </>
  );
}
